import { useEffect } from 'react';
const FOCUSABLE_SELECTOR = ['a[href]', 'button:not([disabled])', 'textarea:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(', ');
export const getFocusableElements = container => container ? Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)) : [];
const wrapFocus = (event, container) => {
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const currentIndex = focusable.indexOf(global.document.activeElement);

  // A currentIndex of -1 means focus sits on a non-tabbable element inside the panel (the screen
  // heading, which we focus on open) or has escaped it entirely; pull it back to an edge.
  if (event.shiftKey && currentIndex <= 0) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (currentIndex === -1 || currentIndex === focusable.length - 1)) {
    event.preventDefault();
    first.focus();
  }
};

/**
 * Keeps Tab navigation inside `containerRef` while active, closes on Escape, and returns focus
 * to whatever was focused before activation (normally the element that opened the panel).
 */
const useFocusTrap = (isActive, containerRef, onEscape) => {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }
    const previouslyFocused = global.document.activeElement;
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onEscape();
        return;
      }
      if (event.key === 'Tab') {
        wrapFocus(event, containerRef.current);
      }
    };
    global.document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      global.document.removeEventListener('keydown', handleKeyDown, true);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    };
  }, [isActive, containerRef, onEscape]);
};
export default useFocusTrap;